/**
 * The placeholder rig's bone layout, shared by the model generator and the
 * animation generator. Offsets are local, in metres, for a ~1.75m figure in
 * a T-pose. Names use the Mixamo convention because that is what the real
 * fighters will ship with.
 */
export const BONES = [
  { name: 'Hips', parent: null, offset: [0, 0.95, 0] },
  { name: 'Spine', parent: 'Hips', offset: [0, 0.12, 0] },
  { name: 'Spine1', parent: 'Spine', offset: [0, 0.13, 0] },
  { name: 'Spine2', parent: 'Spine1', offset: [0, 0.13, 0] },
  { name: 'Neck', parent: 'Spine2', offset: [0, 0.15, 0] },
  { name: 'Head', parent: 'Neck', offset: [0, 0.09, 0] },

  { name: 'LeftShoulder', parent: 'Spine2', offset: [0.05, 0.1, 0] },
  { name: 'LeftArm', parent: 'LeftShoulder', offset: [0.13, 0, 0] },
  { name: 'LeftForeArm', parent: 'LeftArm', offset: [0.27, 0, 0] },
  { name: 'LeftHand', parent: 'LeftForeArm', offset: [0.25, 0, 0] },

  { name: 'RightShoulder', parent: 'Spine2', offset: [-0.05, 0.1, 0] },
  { name: 'RightArm', parent: 'RightShoulder', offset: [-0.13, 0, 0] },
  { name: 'RightForeArm', parent: 'RightArm', offset: [-0.27, 0, 0] },
  { name: 'RightHand', parent: 'RightForeArm', offset: [-0.25, 0, 0] },

  { name: 'LeftUpLeg', parent: 'Hips', offset: [0.09, -0.05, 0] },
  { name: 'LeftLeg', parent: 'LeftUpLeg', offset: [0, -0.42, 0] },
  { name: 'LeftFoot', parent: 'LeftLeg', offset: [0, -0.4, 0] },

  { name: 'RightUpLeg', parent: 'Hips', offset: [-0.09, -0.05, 0] },
  { name: 'RightLeg', parent: 'RightUpLeg', offset: [0, -0.42, 0] },
  { name: 'RightFoot', parent: 'RightLeg', offset: [0, -0.4, 0] },
];

/** Limb volumes: [boneName, childBoneName | null, thickness]. */
export const LIMBS = [
  ['Hips', 'Spine', 0.22],
  ['Spine', 'Spine1', 0.24],
  ['Spine1', 'Spine2', 0.26],
  ['Spine2', 'Neck', 0.24],
  ['Neck', 'Head', 0.09],
  ['Head', null, 0.19],
  ['LeftArm', 'LeftForeArm', 0.1],
  ['LeftForeArm', 'LeftHand', 0.085],
  ['LeftHand', null, 0.08],
  ['RightArm', 'RightForeArm', 0.1],
  ['RightForeArm', 'RightHand', 0.085],
  ['RightHand', null, 0.08],
  ['LeftUpLeg', 'LeftLeg', 0.14],
  ['LeftLeg', 'LeftFoot', 0.115],
  ['LeftFoot', null, 0.1],
  ['RightUpLeg', 'RightLeg', 0.14],
  ['RightLeg', 'RightFoot', 0.115],
  ['RightFoot', null, 0.1],
];
